<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useContentStore } from '../../stores/contentStore';
import Breadcrumbs from './Breadcrumbs.vue';
import ProgressBar from './ProgressBar.vue';
import Logo from '../Common/Logo.vue';
import LanguageSwitch from './LanguageSwitch.vue';

const route = useRoute();

const contentStore = useContentStore();

const state = computed(() => {
    if(['start', 'categories'].includes(route.name)){
        return 'hidden'
    }

    if(route.name === 'category'){
        return 'category'
    }

    if(route.name === 'story'){
        return 'story'
    }

    if(route.name === 'result'){
        return 'result'
    }

    return '';
})


const steps = computed(() => {
    const arr = [];

    arr[0] = {name: 'categories'};
    arr[1] = null;
    arr[2] = null;
    arr[3] = null;


    if(state.value === 'category'){
        arr[1] = {name: 'category', params: {categoryId: route.params.categoryId}};
    }

    if(state.value === 'story'){
        arr[1] = {name: 'category', params: {categoryId: route.params.categoryId}};
        arr[2] = {name: 'story', params: {categoryId: route.params.categoryId, storyId: route.params.storyId}};
    }

    if(state.value === 'result'){
        arr[1] = {name: 'category', params: {categoryId: route.params.categoryId}};
        arr[2] = {name: 'story', params: {categoryId: route.params.categoryId, storyId: route.params.storyId}};
        arr[3] = true;
    }

    return arr;
})

const activeCategory = computed(() => {
    if(['category', 'story', 'result'].includes(route.name)){
        return contentStore.content.categories[route.params.categoryId].self;
    }

    return null;
})

</script>

<template>
    <header v-if="state !== 'hidden'" class="Header fixed top-0 left-0 w-full p-10 4k:p-16 flex items-center gap-x-4 4k:gap-x-6 z-30">
        <ProgressBar :steps="steps" />
        <Breadcrumbs class="ml-auto" :active-category="activeCategory" />
        <div class="w-px self-stretch bg-white"></div>
        <LanguageSwitch />
        <div class="w-px self-stretch bg-white"></div>
        <Logo class="shrink-0" />
    </header>
</template>
